<template>
  <div class="service-max-stations-alarm">
    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <p>
      {{ $t('messages.alarms.serviceMaxStationsAlarm.description') }}
    </p>

    <div class="g-alarm-handler__row">
      <p class="g-alarm-handler__highlight g-alarm-handler__highlight--yellow">
        <strong>{{ $t('messages.alarms.attention') }}:</strong> {{ $t('messages.alarms.serviceMaxStationsAlarm.attention') }}
      </p>
    </div>

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    />

    <hr>

    <!-- <div class="g-alarm-handler__row">
      <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>
        {{ $t('messages.alarms.serviceMaxStationsAlarm.suggestion') }}
      </p>
    </div> -->
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceMaxStationsAlarm',
  mixins: [ServiceAlarm],
  data() {
    return {
      status: false,
      information: {
        status: 25,
        booster1: 25,
        booster2: 25,
        totalPower: 375
      }
    }
  }
}
</script>
